<section class="section-white" *ngIf="customerstateData">
  <div class="section-container-inside">
    <div class="section-trustpilot">
      <div class="align-items-c">
        <figure>
          <img
            src="{{ customerstateData?.logoImageIcon?.fields?.file?.url }}"
            alt="Workpay"
          />
        </figure>
      </div>
      <div
        class="paystack-heading wid-85"
        [innerHtml]="customerstateData?.leftPanelContent | toHtml"
      ></div>
      <div class="revolutionize-team-description align-items-c">
        {{ customerstateData?.leftSubsectionTitle }}
      </div>
    </div>
  </div>
</section>
<ng-container *ngIf="customerstateData">
  <app-trust-pilot
  [bgWhite]="true"
  [paddTop]="true"
></app-trust-pilot>
</ng-container>
